///<reference path="../../shared/utils/csv-export-utils.ts"/>
import { Component } from '@angular/core';
import { Principal } from '../../shared/auth/principal.service';
import { DemandPartnerDbName } from '../../kitchen/shared/domain/demand-partner.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'cm-dp-dashboard',
  templateUrl: './dp-dashboard.component.html',
})
export class DpDashboardComponent {
  isSitesSectionAllowed: boolean;

  constructor(private principal: Principal, private router: Router) {
    this.isSitesSectionAllowed = ![DemandPartnerDbName.EMX, DemandPartnerDbName.BREAL_TIME].includes(this.principal.demandPartner.name);
    if (!this.isSitesSectionAllowed) {
      this.router.navigateByUrl('/dashboard/units');
    }
  }

}
